var map = {
	"./Dashboard.svg": "8ae4",
	"./Exchange.svg": "8020",
	"./History.svg": "1993",
	"./KYC.svg": "405f",
	"./Profile.svg": "9d1c",
	"./Rewards.svg": "2537",
	"./RialDepsoit.svg": "3a11",
	"./RialWithdraw.svg": "e51a",
	"./Settings.svg": "2ddc",
	"./Support.svg": "5dcb",
	"./Trade.svg": "9be1",
	"./Trades.svg": "c91c",
	"./Transactions.svg": "98a8",
	"./Wallets.svg": "caec",
	"./advantage-security.svg": "db10",
	"./alpha.svg": "df05",
	"./arrowdown.svg": "08ef",
	"./calendar.svg": "b8bd",
	"./closecard.svg": "a2e7",
	"./coin-category.svg": "4ebc",
	"./colory-facebook.svg": "5e3a",
	"./colory-instagram.svg": "b0dd",
	"./colory-telegram.svg": "22fa",
	"./colory-twiter.svg": "3ea4",
	"./colory-whatsapp.svg": "5a9f",
	"./copy.svg": "8aac",
	"./en-flag.svg": "d4e8",
	"./fa-flag.svg": "ef9f",
	"./google.svg": "d950",
	"./helping-wolf.svg": "1922",
	"./hidepass.svg": "96e2",
	"./instagram.svg": "bd6c",
	"./level-curved-sec.svg": "b2f1",
	"./level-curved-slice.svg": "6273",
	"./medal.svg": "81c3",
	"./notifications.svg": "f587",
	"./rate-star.svg": "e0a3",
	"./reply-icon.svg": "a585",
	"./search.svg": "d103",
	"./send-icon.svg": "66db",
	"./showpass.svg": "19a8",
	"./telegram.svg": "2b29",
	"./trash.svg": "af22",
	"./twitter.svg": "acf9",
	"./upload-icon.svg": "4052",
	"./whatsapp.svg": "7583",
	"./wolf-level-shadow.svg": "f1ff",
	"./wolf-level.svg": "8532",
	"./احرازهویت.svg": "149c",
	"./معامله.svg": "69c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";